import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { tap, concat, of, from, Subscription, Subject, Observable } from 'rxjs';
import { map, switchMap, concatMap, filter, debounceTime, distinctUntilChanged, concatAll, finalize } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { round1, round2 } from 'src/app/shared/round';

import { Document, DocItems, DocInheritanceRule } from 'src/app/shared/document';
import { Person } from 'src/app/shared/person';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'

import { ProductApiService, StockResult } from 'src/app/services/product-api.service';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { ClientApiService } from 'src/app/services/client-api.service';
import { RestApiService } from 'src/app/services/rest-api.service';

@Component({
  selector: 'app-new-document-dlg-process-tran-sale',
  templateUrl: './new-document-dlg-process-tran-sale.component.html',
  styleUrls: ['./new-document-dlg-process-tran-sale.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgProcessTranSaleComponent implements OnInit, OnChanges, OnDestroy {

  private globalSettinsData: GlobalSettingsData;

  /*
   * Consider that parentDocument may have or may NOT have items property filled with [actual] docItems
   */
  @Input() parentDocument: Document;

  /*
   * Therefore, to keep source object untouched (immutable ????)
   * we will expect alone/independent copy of DocItems as Input parameter
   * 
   */

  @Input() docItems: DocItems[];

  @Input() newDocument: Document;

  @Input() newDocuments: Document[];

  public get hasParentDocument(): boolean { return (this.parentDocumentId && true); }

  @Input() command: number = 0;   /* Command to child components what to do
                                   *
                                   * 0 - nothing / prepare
                                   * 1 - go
                                   * 2 - clean
                                   * 3 - reset to initial state
                                   * 
                                   */
  parentDocumentId: number;

  count: number = -1;

  sourceDocItems: DocItems[];

  blocked: boolean = false;

  @Input() selectedActions: any = [1, 3];

  private newDocumentProcess$ = new Subject<number>();
  private currencyQuery: Subscription;

  private moveOptions$ = new Subject<number>();
  private _moveActionSubs: Subscription;

  private createNewDocument$ = new Subject<Document>();
  private _createNewDoc: Subscription;

  private _childDepQuery: Subscription;
  private _childDocQuery: Subscription;

  private _newDocumentUpdateQuery: Subscription = null;

  private newDocumentUpdateSubs$ = new Subject<Document>();

  @Output() newDocumentUpdate: EventEmitter<Document> = new EventEmitter();

  @Output() onCreateNewDocuments = new EventEmitter<Document[]>();

  constructor(
    private restApi: RestApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private cliApi: ClientApiService,
    private docApi: DocumentApiService,
    private prodApi: ProductApiService,
  ) { }

  createNewDocumentSubscription() {
    this._newDocumentUpdateQuery =
      this.newDocumentUpdateSubs$.pipe(
        debounceTime(20),
        // distinctUntilChanged(),
        tap(document => environment.production || console.log('*** NewDocumentDlgDatesComponent newDocumentUpdateSubs$: ' + JSON.stringify(document))),
        map(document => this.newDocumentUpdate.emit(document)),
      )
        .subscribe();

    this._createNewDoc =
      this.createNewDocument$
        .pipe(
          concatMap(ndi => of(ndi).pipe(map(d => { this.blocked = true; return d; }))),

          concatMap(ndi => this.cliApi.getChildDepartmentsById(ndi.DOCCLIDEPID, ndi.DOCPCOCLIID).pipe(map(d => {

            environment.production || console.log('*** NewDocumentDlgProcessTranSaleComponent in createNewDocument$: getChildDepartmentsById ' + JSON.stringify(d));
            //environment.production || console.table(ndi);

            ndi.DOCPCODEPID = d[0].CLIID;

            return ndi;
          }))),

          concatMap(ndi => this.cliApi.getChildDepartmentsById(ndi.DOCMANDEPID, ndi.DOCLCOCLIID).pipe(map(d => {

            environment.production || console.log('*** NewDocumentDlgProcessTranSaleComponent in createNewDocument$: getChildDepartmentsById ' + JSON.stringify(d));
            //environment.production || console.table(ndi);

            ndi.DOCLCODEPID = d[0].CLIID;

            return ndi;
          }))),

          concatMap(ndi => concat(
            from(this.newDocument.items).pipe(

              filter(di => (di.DOCITEMQTY > 0)),  // Continue only if we really need this product on main stock

              /*
               * Check target stock before
               */
              concatMap(di => this.prodApi.getProductStockBefore(di.PRODID, ndi.DOCCLIENTSID, ndi.DOCCLIDEPID, this.parentDocument.DOCDATE).pipe(map(stock => {
                // 1) Check if stock if gt zero

                di.DOCITEMGLOBALSTOCK = (stock as StockResult[])[0]?.stock ?? 0;

                console.log('*** NewDocumentDlgProcessTranSaleComponent in ngOnInit: process ' + di.PRODCODE + ' Q: ' + di.DOCITEMQTY + ' - Check target stock: ' + ((stock as StockResult[])[0]?.stock ?? 0));

                // Look for only shortage quantity
                // 2) Check if stock has enough items or get only avalable
                //
                // Q S R
                // 1 0 1
                // 3 2 1
                // 1 2 0
                //

                di.DOCITEMQTY = (di.DOCITEMQTY > di.DOCITEMGLOBALSTOCK) ? (di.DOCITEMQTY - di.DOCITEMGLOBALSTOCK) : 0;

                return di;
              }))),

              filter(di => (di.DOCITEMQTY > 0)),  // Continue only if we really need this product on main stock

              /*
               * Check is there any source
               */
              concatMap(di => this.prodApi.getProductStockBefore(di.PRODID, ndi.DOCMANCLIID, ndi.DOCMANDEPID, this.parentDocument.DOCDATE).pipe(map(stock => {
                di.DOCITEMGLOBALSTOCK = (stock as StockResult[])[0]?.stock ?? 0;

                console.log('*** NewDocumentDlgProcessTranSaleComponent in ngOnInit: process ' + di.PRODCODE + ' Q: ' + di.DOCITEMQTY + ' - Check source stock: ' + ((stock as StockResult[])[0]?.stock ?? 0));
                //environment.production || console.table(di);

                if (di.DOCITEMQTY > di.DOCITEMGLOBALSTOCK) {
                  di.DOCITEMQTY = di.DOCITEMGLOBALSTOCK;      // Bring only available quantity
                }

                return di;
              }))),

              filter(di => (di.DOCITEMQTY > 0)),  // Continue only if there is product on the stock

              /*
               * Determine income price to put into receipt
               */
              concatMap(di2 => this.prodApi.getProdIncomePriceById(di2.PRODID, ndi.DOCMANCLIID, ndi.DOCMANDEPID, ndi.DOCCURRID, di2.DOCITEMQTY, ndi.DOCDATE).pipe(map(price => {
                di2.DOCITEMVPRICE = price[0].PRODINCOMEPRICE;

                di2.PRODVAT = (di2.PRODVAT ?? this.globalSettinsData.vatValue);
                di2.DOCITEMPRICE = di2.DOCITEMVPRICE * ndi.DOCRATEVAL;
                di2.DOCITEMPRICEWOVAT = round2(di2.DOCITEMPRICE / ((100.0 + di2.PRODVAT) / 100.0));
                di2.DOCITEMSUM = di2.DOCITEMPRICE * di2.DOCITEMQTY;

                console.log('*** NewDocumentDlgProcessTranSaleComponent in ngOnInit: process ' + di2.PRODCODE + ' Q: ' + di2.DOCITEMQTY + ' - Check source price: ' + price[0].PRODINCOMEPRICE);
                //environment.production || console.table(di2);

                ndi.items.push({ ...di2 });

                return di2;
              }))),

            ),
            of(ndi).pipe(map(doc => {
              if (doc.items.length) {
                console.log('*** NewDocumentDlgProcessTranSaleComponent in ngOnInit C1');
                // environment.production || console.table(doc.items);

                /*
                 * Push only newDocument with content 
                 */
                this.newDocuments.push(doc);

                this.onCreateNewDocuments.emit(this.newDocuments);
              }
              this.blocked = false;

              return of(doc);
            }))
          )),
        )
        .subscribe();
  }

  createMoveSubscriptions() {
    /*
     * This is action to move items to main stock from import and auxilliary stocks
     *
     * Action generates few new documents in queue to fill in by corresponding items
     */
  //  this._move1ActionSubs =
  //    this.a1MoveOptions$
  //      .pipe(
  //        debounceTime(500),
  //        distinctUntilChanged(),
  //        switchMap(options => of(options).pipe(map(o => {
  //          this.newDocuments = [];

  //          let bm: number = 5;     // really it is a second

  //          let od: Date = new Date(this.parentDocument.DOCDATE);

  //          if (o.o1) {

  //            let bd: Date = new Date(od.getFullYear(), od.getMonth(), od.getDate(), od.getHours(), od.getMinutes(), od.getSeconds() - bm++);

  //            this.createNewDocument$.next({

  //              ...this.newDocument,

  //              DOCDATE: bd,
  //              DOCEXPDATE: bd,
  //              DOCVALDATE: bd,

  //              DOCCLIDEPID: this.globalsettingsservice.getGlobalSettings().mainStockId,
  //              DOCMANDEPID: o.s1,

  //              items: []
  //            });
  //          }
  //        }))))

  //      .subscribe();
  }

  createMoveActionSubscription() {
    /*
     *
     * Action selected either during initial call depending on parentDocument type
     * or
     * By selecting Corresponding tab
     *
     * Actually, we could only select between specialized type of move (different for invoice and shipping document for example)
     * and general move - with freely selected stocks
     *
     * Below subscription prepares the view default backend values
     * In general we shouldn't change anything manually
     * 
     */

    this._moveActionSubs =
      this.moveOptions$
        .pipe(
          debounceTime(300),
          switchMap(options => of(options).pipe(map(action => {
            console.log('*** NewDocumentDlgProcessTranSaleComponent in _moveActionSubs: data=(' + JSON.stringify(action) + ')');

          })))
        )
        .subscribe();
  }

  createNewDocumentProcessSubscription() {

    let rowSortIndex: number;

    this.currencyQuery =
      this.newDocumentProcess$
        .pipe(
          debounceTime(300),

          switchMap(options => { /*this.blocked = true*/; return of(options); }),

          concatMap(options => this.restApi.getCurrencyInfoByID(options)),

          concatMap(rate => {
            this.newDocument.DOCRATEVAL = rate[0].CURRATE;
            this.newDocument.DOCNOTE2 = '$MOVE$ внутреннее перемещение товара между нашими компаниями';
            this.newDocument.items = [];
            rowSortIndex = 10;

            return from((this.sourceDocItems || []));
          }),

          filter(di => (di.DOCITEMQTY > 0)),

          /*
           * Check is there any debt on local stock as for current moment
           */
          concatMap(di => this.prodApi.getProductLcStockBefore(di.PRODID, this.newDocument.DOCCLIENTSID, this.newDocument.DOCCLIDEPID, this.newDocument.DOCPCODEPID, new Date()).pipe(map(stock => {
            di.DOCITEMLOCALSTOCK = (stock as StockResult[])[0]?.stock ?? 0;

            console.log('*** NewDocumentDlgProcessTranSaleComponent in createNewDocumentProcessSubscription: E1 ' + di.PRODCODE + ' Q: ' + di.DOCITEMQTY + ' - Check target stock: ' + ((stock as StockResult[])[0]?.stock ?? 0));

            di.DOCITEMQTY = (di.DOCITEMLOCALSTOCK < 0) ? -di.DOCITEMLOCALSTOCK : 0;

            return di;
          }))),

          filter(di => (di.DOCITEMQTY > 0)),  // Continue only if there is debt on local stock

          concatMap(di => {
            //environment.production || console.table(di);
            environment.production || console.log('*** NewDocumentDlgProcessTranSaleComponent in createNewDocumentProcessSubscription: ndi ' + di.PRODCODE + ' Q: ' + di.DOCITEMQTY);

            let ndi: DocItems = {
              ...di,
              ... {
                DOCITEMID: -2,
                cloneIndex: 0,
                U4ETKA: null,
                DOCITEMCURRID: this.newDocument.DOCCURRID,
                DOCITEMCRATE: this.newDocument.DOCRATEVAL,
                PAYITEMCLIID: rowSortIndex,
                PRODVAT: di.PRODVAT ?? this.globalSettinsData.vatValue,
              }
            };

            rowSortIndex += 10;

            ndi.DOCITEMPRICE = di.DOCITEMPRICE;
            di.DOCITEMVPRICE = round2(di.DOCITEMPRICE / this.newDocument.DOCRATEVAL);
            if (this.selectedActions.includes(1)) {

              ndi.DOCITEMVPRICE = di.DOCITEMVPRICE;
              di.DOCITEMPRICE = round2(di.DOCITEMVPRICE * this.newDocument.DOCRATEVAL);
            }

            ndi.DOCITEMPRICEWOVAT = round2((di.DOCITEMVPRICE * this.newDocument.DOCRATEVAL) / ((100.0 + ndi.PRODVAT) / 100.0));
            ndi.DOCITEMSUM = ndi.DOCITEMPRICE * ndi.DOCITEMQTY;

            this.newDocument.items.push(ndi);
            return of(ndi);
          }),
          finalize(() => {
            this.newDocuments.push(this.newDocument);
            environment.production || console.table(this.newDocuments);
            this.onCreateNewDocuments.emit(this.newDocuments);
            this.blocked = false;
          })
        )
      .subscribe({
        next: (ndi) => {
          environment.production || console.log('*** NewDocumentDlgProcessTranSaleComponent in createNewDocumentProcessSubscription: process ' + ndi.PRODCODE + ' Q: ' + ndi.DOCITEMQTY + ' P: ' + ndi.DOCITEMPRICE);
        },
        error: (err) => {
          this.blocked = false;
          console.error('Error occurred while processing new document: ', err);
        }
      });
  }

  // This procedure used to fill in department and person for almost all type of documents
  //
  fillInChildDocumentDepartmentAndPerson(doc: Document): Observable<Document> {
    environment.production || console.log('*** CreateNewDocumentComponent before fillInChildDocumentDepartmentAndPerson: ' + JSON.stringify(doc));
    return of(doc).pipe(

      // Our side effect - fill in department and person for local company
      concatMap(ndi => this.cliApi.getChildDepartmentsById(ndi.DOCMANDEPID, ndi.DOCLCOCLIID).pipe(map(d => {
        if (d && (d.length > 0)) {
          ndi.DOCLCODEPID = d[0].CLIID;
        } else {
          ndi.DOCLCODEPID = ndi.DOCMANDEPID; // If no child department, use parent one. Wrong idea but what else?
          environment.production || console.log('*** CreateNewDocumentComponent in fillInChildDocumentDepartmentAndPerson (no child department): ' + JSON.stringify(d));
        }
        return ndi;
      }))),

      // Their side effect - fill in department and person for partner company
      concatMap(ndi => this.cliApi.getChildDepartmentsById(ndi.DOCCLIDEPID, ndi.DOCPCOCLIID).pipe(map(d => {
        if (d && (d.length > 0)) {
          ndi.DOCPCODEPID = d[0].CLIID;
        } else {
          ndi.DOCPCODEPID = ndi.DOCCLIDEPID; // If no child department, use parent one. Wrong idea but what else?
          environment.production || console.log('*** CreateNewDocumentComponent in fillInChildDocumentDepartmentAndPerson (no child department): ' + JSON.stringify(d));
        }
        return ndi;
      }))),

      // Our side effect - fill in person for local company
      concatMap(ndi => this.cliApi.getPersonsByClientId(ndi.DOCLCOCLIID).pipe(map(prs => {
        let dir: Person = prs.sort((a, b) => (b.PERSRESPONSIBLE - a.PERSRESPONSIBLE)).find(pr => pr.PERSRESPONSIBLE > 0);
        if (dir) {
          ndi.DOCLCOPERID = dir.PERSID;
        } else
          if (prs.length > 0) {
            ndi.DOCLCOPERID = prs[0].PERSID;
          } else {
            ndi.DOCLCOPERID = ndi.DOCMANPERID; // If no person found, use document one. Wrong idea but what else?
            environment.production || console.log('*** CreateNewDocumentComponent in fillInChildDocumentDepartmentAndPerson (no person): ' + JSON.stringify(prs));
          }
        return ndi;
      }))),

      // Their side effect - fill in person for partner company
      concatMap(ndi => this.cliApi.getPersonsByClientId(ndi.DOCPCOCLIID).pipe(
        map(prs => {
          let dir: Person = prs.sort((a, b) => (b.PERSRESPONSIBLE - a.PERSRESPONSIBLE)).find(pr => pr.PERSRESPONSIBLE > 0);
          if (dir) {
            ndi.DOCPCOPERID = dir.PERSID;
          } else
            if (prs.length > 0) {
              ndi.DOCPCOPERID = prs[0].PERSID;
            } else {
              ndi.DOCPCOPERID = ndi.DOCPERSONID; // If no person found, use document one. Wrong idea but what else?
              environment.production || console.log('*** CreateNewDocumentComponent in fillInChildDocumentDepartmentAndPerson (no person): ' + JSON.stringify(prs));
            }
          return ndi;
        }))),

      finalize(() => {
        environment.production || console.log('*** CreateNewDocumentComponent after fillInChildDocumentDepartmentAndPerson: ' + JSON.stringify(doc));
      })
    );
  }

  setInitialValues() {
    console.log('*** NewDocumentDlgProcessTranSaleComponent setInitialValues');

    if (this.parentDocument) {
      // Here we need to set LCO/PCO stock and client according to parent document
      // If parnet document is recive order we have to set LCO from LCO in parent document
      // PCO should be set by manual selection

      switch (this.parentDocument.DOCTYPE) {

        case 2:   // Invoice
        case 3:   // Import Invoice
          this.selectedActions = [1, 3];

          this.newDocument.DOCLCOCLIID = this.parentDocument.DOCLCOCLIID;
          // this.newDocument.DOCLCODEPID = this.parentDocument.DOCLCODEPID;

          break;

        // If parent document is move document - we have to set LCO as PCO in parent document

        case 5:   // Move Document

          let bm: number = 5; // seconds offset to preserve ordering
          const od: Date = new Date(this.parentDocument.DOCDATE);

          const bd = new Date(od.getFullYear(), od.getMonth(), od.getDate(), od.getHours(), od.getMinutes(), od.getSeconds() - bm++);

          this.newDocument.DOCDATE = bd;
          this.newDocument.DOCEXPDATE = bd;
          this.newDocument.DOCVALDATE = bd;

          this.newDocument.DOCPCOCLIID = this.parentDocument.DOCLCOCLIID;
          //this.newDocument.DOCLCODEPID = this.parentDocument.DOCPCODEPID;
          this.selectedActions = [1, 3];
          this.newDocumentUpdateSubs$.next(this.newDocument);
          break;

        // Here do nothing with LCO/PCO - it should be set manually
        default:
          this.selectedActions = [3];
          break;
      }
    }

    this.fillInChildDocumentDepartmentAndPerson(this.newDocument).pipe(
      finalize(() => {
        this.newDocument.DOCNOTE1 = this.newDocument.DOCDATE.toDateString();
        this.newDocument.DOCNOTE2 = '$MOVE$ внутреннее перемещение товара между нашими компаниями';

        this.newDocument = this.newDocument;                // Do nothing by fact - just to trigger ngOnChanges in child components
        this.newDocumentUpdateSubs$.next(this.newDocument);
        this.loadChildDocuments();
      })
      ).subscribe();
  }

  processDocItems() {
    console.log('*** NewDocumentDlgProcessTranSaleComponent in processDocItems');

    //this.createNewDocumentSubscription();
    //this.createMoveSubscriptions();
    //this.createNewDocumentProcessSubscription();
    //this.createMoveActionSubscription();

    /*
     * Here we come with newDocument prepared in createNewDocument initial procedure
     *
     * Furthe we have to process document content
     * to prepare the inital template for further processing
     *
     * Target stock already set
     * 
     * Get Actual currency rate for newDocument
     * And process all items when Currency Rate become available
     * 
     * Those one in newDocument.DOCRATEVAL from createNewDocument Dialog would arrive later
     *
     * Aware on $MOVE$ in DOCNOTE2 - it is internal marker for move documents
     * 
     */
    this.newDocumentProcess$.next(this.newDocument.DOCCURRID);
  }

  loadChildDocuments() {

    this.newDocuments = [];
    this._childDocQuery =
      this.docApi.getChildDocList(this.parentDocument.DOCID).pipe(

        filter(docList => (docList && (docList.length > 0))),

        concatMap(docList => from(docList.filter(dl => (dl && dl.DOCACTIVE && (dl.DOCTYPEID == 5) && ((dl.DOCNOTE2 ?? '').includes('$MOVE$')))))),

        concatMap(doc => this.docApi.getDocumentById(doc.DOCID)),
        concatMap(doc => from(doc)),

        filter(doc => ((doc.DOCPCODEPID == this.newDocument.DOCPCODEPID) && (doc.DOCPCOCLIID == this.newDocument.DOCPCOCLIID))),

        concatMap(doc => this.docApi.getDocItemsByDoc(doc.DOCID).pipe(map(items => {

          doc.items = items;
          this.newDocuments.push(doc);

          return doc;
        }))),

        finalize(() => {

          if (this.newDocument.DOCPCOCLIID && (this.newDocuments.length < 1)) {
            this.newDocuments = [this.newDocument];
          }

          environment.production || console.table(this.newDocuments);
          this.onCreateNewDocuments.emit(this.newDocuments);
        }))
      .subscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];

      environment.production || console.log('*** NewDocumentDlgProcessTranSaleComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {

        case 'command':
          switch (change.currentValue) {
            case 0:
              this.createNewDocumentSubscription();
              this.createMoveSubscriptions();
              this.createNewDocumentProcessSubscription();
              this.createMoveActionSubscription();

              break;

            case 1:
              this.processDocItems();
              break;

            case 2:
              this.newDocuments = [];
              this.onCreateNewDocuments.emit(this.newDocuments);
              break;

            case 3:
              this.setInitialValues();
              break;

          }
          break;

        case 'newDocument':
          if (this.newDocument) {
            //this.processDocItems();
          }
          break;

        case 'docItems':
          if (this.docItems) {
            this.sourceDocItems = [... this.docItems];
            this.count = this.sourceDocItems.length;

          }
          break;

        case 'parentDocument':
          this.loadChildDocuments();
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgProcessTranSaleComponent in ngOnDestroy')

    if (this.currencyQuery) { this.currencyQuery.unsubscribe(); }

    if (this._moveActionSubs) { this._moveActionSubs.unsubscribe(); }
    if (this._createNewDoc) { this._createNewDoc.unsubscribe(); }

    if (this._childDepQuery) { this._childDepQuery.unsubscribe(); }
    if (this._childDocQuery) { this._childDocQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgProcessTranSaleComponent in ngOnInit');

    /*
     * TODO: Make subscription to newDocument currency rate, because it is quite complex task to wait the set the rate in the main thread
     * Potentially problematic due to different sources ??????
     */

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.setInitialValues();
  }

  onClearRows(event) {
    console.log('*** NewDocumentDlgProcessTranSaleComponent onClearRows ' + JSON.stringify(event));

    this.newDocuments = [];
    this.onCreateNewDocuments.emit(this.newDocuments);
  }

  onRefreshRows(event) {
    console.log('*** NewDocumentDlgProcessTranSaleComponent onRefreshRows ' + JSON.stringify(event));

    this.setInitialValues();
    this.newDocuments = [];
    this.onCreateNewDocuments.emit(this.newDocuments);
  }

  lcoCompanySelected(selectedId) {
    console.log('*** NewDocumentDlgProcessTranSaleComponent in lcoCompanySelected: ' + selectedId);

    this.newDocument.DOCPCOCLIID = selectedId;

    this._childDocQuery =
      this.cliApi.getChildDepartmentsById(this.newDocument.DOCMANDEPID, this.newDocument.DOCPCOCLIID)
      .pipe(
        filter(d => (d && (d.length > 0))),
        map(d => this.newDocument.DOCPCODEPID = d[0].CLIID),

        finalize(() => {
          this.loadChildDocuments();
        })
      )
        .subscribe();
  }

  mainStockSelected(selectedId) {
    console.log('*** NewDocumentDlgProcessTranSaleComponent in mainStockSelected: ' + selectedId);

    this.newDocument.DOCPCODEPID = selectedId;
    this.loadChildDocuments();
  }
}
